import { Injectable } from '@kaokei/use-vue-service';

/**
 * 整个页面的音视频资源需要集中管理
 *
 * @export
 * @class AudioManagerService
 */
@Injectable()
export class AudioManagerService {
  public currentAudio?: HTMLAudioElement;

  public remove() {
    const audio = this.currentAudio;
    if (audio) {
      audio.pause();
      this.currentAudio = undefined;
    }
  }

  public pause(audio?: HTMLAudioElement) {
    if (audio && !audio.paused) {
      audio.pause();
    }
  }

  public stop(audio?: HTMLAudioElement) {
    if (audio) {
      this.pause(audio);
      audio.currentTime = 0;
    }
  }

  public play(audio?: HTMLAudioElement) {
    if (audio && audio.paused) {
      audio.play();
    }
  }

  public toggle(audio?: HTMLAudioElement) {
    if (audio) {
      if (audio.paused) {
        this.stop(this.currentAudio);
        this.play(audio);
        this.currentAudio = audio;
      } else {
        this.stop(audio);
      }
    }
  }
}
